/**
 * Renders an input search
 * Rendered in GridPage.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';

export default class SearchByName extends React.PureComponent {

    render() {
        return (
            <div className='grid-search-input'>
                <input
                    type={this.props.type}
                    placeholder={strings.search_by_name}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    className={this.props.className}
                />
            </div>
        );
    }
}